@if (content) {
<button class="pos-absolute flex flex-middle z-1 left-4-x left-4-l right-4-s right-4-m top-6-x top-6-l top-4-m top-4-s b-radius-max p-a bg-col-w cursor-pointer _close-btn"
        type="button"
        (click)="close()"
        aria-label="Close modal window">
    <i class="flex flex-middle fs-3 icon-close"
       aria-hidden="true"></i>
    <ng-container *ifSize="'XL'">
        <span class="flex flex-middle h4 p-l-3"
              *iCms="'btnCopy' of content"></span>
    </ng-container>
</button>
<modal-layout-middle class="flex flex-justify-center-x flex-middle-x overflow-y-auto flex-justify-center-l flex-middle-l  flex-column-s w-12-s flex-column-m w-12-m"
                     [ngClass]="{'bg-col-1-s bg-col-1-m flex-justify-center-s flex-justify-center-m' : !(data?.products?.length > 1)}">
    <!-- close button -->
    <!-- image -->
    <div class="_img-wrap p-a p-a-0-s p-a-0-m bg-col-1">
        <div class="w-12 ratio-1-1"
             (offClick)="close()">
            @switch (data.model.data.content_type) {
            <!--klevu trending products -->
            @case ('vimeo') {
            <vimeo-player [video-url]="data.model.data.url"
                          class="bg-col-1 _vimeo-player"
                          [autoplay]="true"
                          [loop]="true"
                          [controls]="true"
                          [muted]="true">
            </vimeo-player>
            }
            @default {
            <img class="rf"
                 [image]="data.model.data.image" />
            }
            }
        </div>
    </div>
    @if (data?.products?.length > 0 ) {
    <div class="_shop-the-look-wrapper bg-col-1 p-r-2 p-t p-b p-l-4-s p-l-4-m flex flex-column">
        <div class="flex flex-middle m-t-10 m-b-3 m-b-5-s m-t-5-s">
            <i class="icon-user col-12 p-r-3 p-r-2-s flex flex-middle"
               style="font-size:25px;"></i>
            <span class="s2 col-w">{{data.model.data.user_tag}}</span>
        </div>
        <div class="overflow-y-auto custom-scrollbar"
             style="max-height: 100%">
            <div class="p-b-16-s p-b-16-m">
                @for (product of data.products; track product) {
                <div class="w-12 w-6-s w-6-m p-b-5 p-r-2">
                    <div class="ratio-1-1">
                        <img class="rf"
                             [image]="product.data.image" />
                    </div>
                    <p class="s3 col-w m-t-3">{{product.data.name}}</p>
                    <href [link]="product.data.url">
                        <div class="pos-relative m-t-2"
                             (click)="productClickClose()">
                            <div style="border-radius:40px"
                                 class="fill bg-col-w b-a b-col-1"></div>
                            <div class="button-1 pos-relative z-1 bg-col-w w-12">Shop Now</div>
                        </div>
                    </href>

                </div>
                }
            </div>
        </div>
    </div>

    }
</modal-layout-middle>
}
